<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7YPScy/tc-custom/9781449442705.jpg?1707968559606" alt="This image is the cover for the book Close to Home: Uncut, Close to Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Close to Home: Uncut, Close to Home
      </h1>
      <p class="bookDescription body article font2">
        <p>Only in the world of <i>Close to Home</i> can you find hospitals staffed with hypochondriac-sniffing dogs, Yellowstone employees who secretly spike Old Faithful with gallons of Mr. Bubble, and telephones equipped with Caller I.Q. Of course, for the creator of the screamingly successful <i>Close to Home</i>, it's just another no-holds-barred day at the drawing board.</p><p>Specializing in humor in everyday situations, John McPherson lampoons the worlds of parenting, marriage, school, health care, work, and leisure in ways that get readers to laugh at themselves.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John McPherson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aab96876